import axios from "axios";
export async function getList() {
   let res = await axios("/api/v1/notifications/");
   console.log("notifications", res.data);
   return res.data;
}
